module.exports = __webpack_public_path__ + "img/fs_sanji.da726b9c.png";